import { render } from "./ButtonSocialMedia.vue?vue&type=template&id=fd209238"
const script = {}
script.render = render

export default script